import React, { createContext, useContext, useEffect, useMemo, useState } from 'react'

const Ctx = createContext(undefined)

export function NotificationProvider({ children }) {
    const [badgeCount, setBadgeCount] = useState(0)
    const [notifications, setNotifications] = useState([])

    useEffect(() => {
        function onNew(e) {
            const payload = e?.detail || {}
            const id = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`
            setBadgeCount((n) => n + 1)
            setNotifications((arr) => [{ id, payload, receivedAt: new Date().toISOString() }, ...arr].slice(0, 100))
        }
        window.addEventListener('notifications:new', onNew)
        return () => window.removeEventListener('notifications:new', onNew)
    }, [])

    const value = useMemo(() => ({
        badgeCount,
        notifications,
        markAllRead: () => setBadgeCount(0),
        clear: () => { setBadgeCount(0); setNotifications([]) },
        dismiss: (id) => {
            setNotifications((arr) => arr.filter((n) => n.id !== id))
            setBadgeCount((n) => (n > 0 ? n - 1 : 0))
        },
    }), [badgeCount, notifications])

    return <Ctx.Provider value={value}>{children}</Ctx.Provider>
}

export function useNotifications() {
    const ctx = useContext(Ctx)
    if (!ctx) throw new Error('useNotifications must be used within NotificationProvider')
    return ctx
}


